import AirportLocationModal from '@/components/Airport/AirportLocationModal';
import ReceiptLayout from '@/components/Receipt/ReceiptLayout';
import {
  AIRPORT_FORCE_REFUND_PROCESS_BOXES,
  AIRPORT_REFUND_PROCESS_BOXES,
  AIRPORT_REFUND_PROCESS_BOXES_KOR,
} from '@/constants/guide.const';
import { routes } from '@/constants/routes.const';
import useGetAirportList from '@/hooks/useGetAirportList';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { IMG_CASH_PICKUP_GUIDE_MAIN } from '@repo/assets';
import { CashPickupIntroBox, TextButton } from '@repo/components';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const AirportGuide = () => {
  const history = useHistory();
  const { passportNumber, nationality, hasTakeOutNumber } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const selectedAirport =
    passportNumber && localStorage.getItem(passportNumber);
  const [isOpenLocationModal, setIsOpenLocationModal] = useState(false);

  useGetAirportList(passportNumber);

  const switchGuide = () => {
    // 한국인은 반출승인번호 유무와 관계없이 반출승인번호가 있는 경우의 안내로 진행
    if (nationality !== 'KOR' && !hasTakeOutNumber) {
      return AIRPORT_FORCE_REFUND_PROCESS_BOXES;
    } else {
      return nationality === 'KOR'
        ? AIRPORT_REFUND_PROCESS_BOXES_KOR
        : AIRPORT_REFUND_PROCESS_BOXES;
    }
  };

  const handleNext = () => {
    localStorage.setItem('isReadAirportGuide', 'yes');
    history.push(routes.airport);
  };

  return (
    <ReceiptLayout hasPadding={false}>
      <MainImage
        src={IMG_CASH_PICKUP_GUIDE_MAIN}
        alt='CashPickupGuideMainImage'
      />
      <InnerWrapper>
        <Title>KTP Tax Refund Process</Title>
        <BoxWrapper>
          {switchGuide().map((box) => (
            <CashPickupIntroBox key={box.index} {...box} />
          ))}
        </BoxWrapper>
        <BtnWrapper>
          {/* {!hasTakeOutNumber && (
            <Button
              enabled
              onClick={() => history.push(routes.locationPrint)}
              size='lg'
              style={{ marginBottom: '12px' }}
            >
              {nationality === 'KOR'
                ? '공항 프린트기 위치'
                : 'Airport Printer Location'}
            </Button>
          )} */}
          <TextButton
            title={nationality === 'KOR' ? '환급 받기' : 'Go to get Tax Refund'}
            onClick={handleNext}
          />
        </BtnWrapper>
      </InnerWrapper>
      <AirportLocationModal
        isOpen={isOpenLocationModal}
        onClose={() => setIsOpenLocationModal(false)}
        selectedAirport={selectedAirport || ''}
      />
    </ReceiptLayout>
  );
};

const MainImage = styled.img`
  width: 100%;
  height: auto;
`;

const Title = styled.h1`
  color: var(--KTP-Grayscale-Gray_02, #111);
  font-size: 24px;
  font-weight: 700;
  line-height: 150%; /* 36px */
  letter-spacing: -0.48px;
`;

const InnerWrapper = styled.div`
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const BoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
`;

const BtnWrapper = styled.div``;

export default AirportGuide;
